// src/components/GioiThieu.js
import React, { useState, useEffect } from "react";
import AboutSection from "./components/AboutSection";
import AchievementSection from "./components/AchievementSection";
import ServiceSection from "./components/ServiceSection";
import ProductSection from "./components/ProductSection";
import ProjectShowcase from "./components/ProjectShowcase";
import TestimonialsSection from "./components/TestimonialsSection";
import PartnerSlider from "./components/PartnerSlider";
import VideoSection from "./components/VideoSection";
import LocationSection from "./components/LocationSection";
import useScrollReveal from "../../assets/hooks/useScrollReveal/useScrollReveal";
import { Helmet } from "react-helmet-async";
const Home = ({ headerHeight, currentUserd }) => {
  const [installPrompt, setInstallPrompt] = useState(null);
  const [aboutRef, isAboutVisible] = useScrollReveal({ threshold: 0.2 });
  const [achievementRef, isAchievementVisible] = useScrollReveal({
    threshold: 0.2,
  });
  const [serviceRef, isServiceVisible] = useScrollReveal({ threshold: 0.2 });
  const [productRef, isProductVisible] = useScrollReveal({
    threshold: 0.2,
  });
  const [projectRef, isProjectVisible] = useScrollReveal({ threshold: 0.2 });
  const [testimonialsRef, isTestimonialsVisible] = useScrollReveal({
    threshold: 0.2,
  });
  const [videoRef, isVideoVisible] = useScrollReveal({ threshold: 0.2 });
  // Hàm tiện ích để tạo tên lớp CSS
  const getRevealClass = (isVisible) =>
    `scroll-reveal-item ${isVisible ? "is-visible" : ""}`;
  useEffect(() => {
    // 1. Trình duyệt sẽ phát sự kiện này nếu web đủ điều kiện cài đặt
    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setInstallPrompt(e); // Lưu sự kiện lại để dùng khi nhấn nút
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstall);
    return () =>
      window.removeEventListener("beforeinstallprompt", handleBeforeInstall);
  }, []);

  const handleInstallApp = async () => {
    if (!installPrompt) return;

    installPrompt.prompt(); // Hiện bảng hỏi cài đặt của trình duyệt
    const { outcome } = await installPrompt.userChoice;
    if (outcome === "accepted") {
      setInstallPrompt(null);
    }
  };
  return (
    <nav className="page__content">
      <Helmet>
  <title key="home">Habako M&E | Cung Cấp Thiết Bị & Giải Pháp Cơ Điện Uy Tín</title>
  <meta name="description" content="Chuyên cung cấp vật tư cơ điện, thiết bị công nghiệp và giải pháp M&E toàn diện cho các công trình. Uy tín, chất lượng tại Việt Nam." />
</Helmet>
      {(currentUserd?.role === "Admin" || currentUserd?.role === "Staff") &&
        installPrompt && (
          <div
            className="admin-install-banner"
            style={{
              background: "#ff4d4f",
              color: "#fff",
              padding: "15px",
              textAlign: "center",
              position: "fixed",
              bottom: 0,
              width: "100%",
              zIndex: 1000,
            }}
          >
            <span>
              Bạn đang đăng nhập với quyền Admin. Cài đặt App để quản lý tiện
              hơn?
            </span>
            <button
              onClick={handleInstallApp}
              style={{
                marginLeft: "15px",
                padding: "5px 15px",
                background: "#fff",
                color: "#ff4d4f",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              CÀI ĐẶT NGAY
            </button>
          </div>
        )}
      <AboutSection headerHeight={headerHeight} />
      {}
      <AchievementSection />
      {}
      <ServiceSection />
      <ProductSection />
      <ProjectShowcase />
      <VideoSection />
      <TestimonialsSection />
      <PartnerSlider />
      <LocationSection />
    </nav>
  );
};

export default Home;
